import { ReactElement, useCallback, useEffect, useState } from 'react';
import SandboxPromiseModal from '@/framework/events/SandboxPromiseModal';
import { useTranslation, useWallet } from '@/services';
import TokenName from '@/components/token/TokenName';
import { Modal } from 'antd';
import styles from '@/styles/pages/admin/sandbox-modal.module.less';
import { useSwapTokenController } from '@/services/contracts';
import HttpUtils from '@/framework/HttpUtils';
import LocalImage from '@/components/LocalImage';
import { ethers } from 'ethers';
interface SwapInfo {
    tokenIn: string;
    tokenOut: string;
    amountIn: string;
    amountOut: string;
}
const WalletSwap = (): ReactElement => {
    const { t } = useTranslation('admin', 'admin.common');
    const { swap, getAmountOut } = useSwapTokenController();
    const { logged, chainName, address } = useWallet();
    //token 名称
    const [tokenSymbol, setTokenSymbol] = useState(new Map());
    //token Icon
    const [tokenIcon, setTokenIcon] = useState(new Map());

    const [swapData, setSwapData] = useState(undefined as undefined | SandboxPromiseModalData<string, SwapInfo>);
    //token信息
    const [swapTokenInfo, setSwapTokenInfo] = useState<SwapTokenInfo>({ tokenInSymbol: '', tokenOutSymbol: '', tokenInIcon: '', tokenOutIcon: '' });

    const initToken = async () => {
        const params = {
            scene: 'swap',
        };

        const tokens = await HttpUtils.Get('/token/listings', params);
        const resp = tokens as unknown as TokenResp[];
        const tokenMap = new Map();
        const tokenIconMap = new Map();
        resp.forEach((token) => {
            tokenMap.set(token.assetContractAddress, token.symbol);
            tokenIconMap.set(token.assetContractAddress, token.icon);
        });
        setTokenSymbol(tokenMap);
        setTokenIcon(tokenIconMap);
    };

    useEffect(() => {
        if (!logged) {
            return;
        }
        initToken();
        setSwapData(undefined);
        SandboxPromiseModal.On('Sandbox.Wallet.Swap', setSwapData);
        return () => SandboxPromiseModal.Remove('Sandbox.Wallet.Swap');
    }, [logged, chainName, address, setSwapData]);

    const onCancel = useCallback(() => {
        if (!swapData) {
            return;
        }
        swapData.Reject('User cancel.');
        setSwapData(undefined);
    }, [setSwapData, swapData]);

    const onOk = useCallback(async () => {
        setSwapTokenInfo({ tokenInSymbol: tokenSymbol.get(swapData?.Data.tokenIn), tokenOutSymbol: tokenSymbol.get(swapData?.Data.tokenOut), tokenInIcon: tokenIcon.get(swapData?.Data.tokenIn), tokenOutIcon: tokenIcon.get(swapData?.Data.tokenOut) });
        if (swapData?.Data.tokenIn) {
            const outTokenAmount = await getAmountOut(swapData?.Data.tokenIn, swapData?.Data.tokenOut, swapData?.Data.amountIn);
            swapData.Resolve(ethers.utils.formatUnits(outTokenAmount));
        }
        if (swapData?.Data.tokenIn) swap(swapData?.Data.tokenIn, swapData?.Data.tokenOut, swapData?.Data.amountIn, swapTokenInfo);
        if (!swapData) {
            return;
        }
        setSwapData(undefined);
    }, [setSwapData, swapData, swap]);
    //弹窗-》您正在XX游戏中，
    //使用20.00 XX(toekn) swap 30.00 xxx(token)
    //取消，确认交易（签名）
    return (
        <Modal maskClosable={false} centered styles={{ body: styles }} closeIcon={<LocalImage dir="/images/wallet" name="close-x" type="svg" width="20" />} okText={t('sub-btn-name')} cancelText={t('cancel')} title="您正在XX游戏中" open={swapData != undefined} cancelButtonProps={cancelButton} okButtonProps={okButton} onCancel={onCancel} onOk={onOk}>
            {swapData ? <WalletInfoElt {...swapData.Data} /> : <></>}
        </Modal>
    );
};

const WalletInfoElt = (props: SwapInfo): ReactElement => {
    return (
        <div className={styles['title']}>
            <p key={1}>
                使用 {props.amountIn} <TokenName token={props.tokenIn} /> 交换 {props.amountOut}
                <TokenName token={props.tokenOut} />
            </p>
        </div>
    );
};
//取消按钮样式
const cancelButton = { style: { backgroundColor: '#05B8A4', color: '#FFFFFF', border: 0, height: 42, width: 196, fontSize: 16, borderRadius: 10, fontFamily: 'Montserrat-Bold' } };
const okButton = { style: { backgroundColor: '#FF5029', color: '#FFFFFF', border: 0, height: 42, width: 196, fontSize: 16, borderRadius: 10, fontFamily: 'Montserrat-Bold' } };
export default WalletSwap;
